import { baseElementSchema } from "@/Components/Exercises/Elements/base";
import {
    numberReturnOpSchema,
    stringArrayReturnOpSchema,
    stringReturnOpSchema,
} from "@/Components/Exercises/LogicOperation";
import { z } from "zod";

export const writeMultipleTextsElementSchema = baseElementSchema.extend({
    type: z.literal("writeMultipleTexts"),
    question: z.union([z.string(), stringReturnOpSchema]),
    noun: z
        .union([z.string(), stringReturnOpSchema])
        .optional()
        .describe("Noun to use in the input fields. Default is 'topic'."),
    defaultTexts: z
        .union([stringArrayReturnOpSchema, z.array(z.string())])
        .optional()
        .describe(
            "Default texts to show in the input fields. If not provided, the user can add their own texts.",
        ),
    minTexts: z
        .union([z.number(), numberReturnOpSchema])
        .optional()
        .describe("Minimum number of texts the user can add."),
    maxTexts: z
        .union([z.number(), numberReturnOpSchema])
        .optional()
        .describe("Maximum number of texts the user can add."),
});
export const writeMultipleTextsElementDataSchema = z.object({
    texts: z.array(z.string()),
});
export type WriteMultipleTextsElement = z.infer<
    typeof writeMultipleTextsElementSchema
>;
export type WriteMultipleTextsElementData = z.infer<
    typeof writeMultipleTextsElementDataSchema
>;
